<template>
  <FlexColumn class="mt-4 mx-12">
    <FlexRow justify="end">
      <Button color="primary" @click="() => createTemplate = {}">新規作成</Button>
    </FlexRow>
    <FlexRow justify="center">
      <v-simple-table>
        <tbody>
        <tr v-for="template in scoutTemplates" :key="template.id">
          <td style="width: 480px">{{template.name}}</td>
          <td style="width: 60px">
            <Button text @click="editTemplate = template">
              <v-icon>mdi-pencil</v-icon>
            </Button>
          </td>
          <td style="width: 60px">
            <Button text @click="deleteTemplate = template">
              <v-icon>mdi-delete</v-icon>
            </Button>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </FlexRow>
    <ScoutMessageTemplateCreateDialog
        :open="createTemplate !== undefined"
        :companyId="companyId"
        @close="createTemplate = undefined"
    />
    <ScoutMessageTemplateEditDialog
        :open="editTemplate !== undefined"
        :template="editTemplate"
        :companyId="companyId"
        @close="editTemplate = undefined"
    />
    <ScoutMessageTemplateDeleteDialog
        :open="deleteTemplate !== undefined"
        :template="deleteTemplate"
        :companyId="companyId"
        @close="deleteTemplate = undefined"
    />
  </FlexColumn>
</template>

<script>
import {mapGetters} from "vuex";
import ApiMixin from "../../ApiMixin";
import FlexColumn from "../atoms/FlexColumn.vue";
import FlexRow from "../atoms/FlexRow.vue";
import Button from "../atoms/Button.vue";
import ScoutMessageTemplateCreateDialog from "./ScoutMessageTemplateCreateDialog.vue";
import ScoutMessageTemplateDeleteDialog from "./ScoutMessageTemplateDeleteDialog.vue";
import ScoutMessageTemplateEditDialog from "./ScoutMessageTemplateEditDialog.vue";

export default {
  name: "ScoutMessageTemplates",
  components: {
    ScoutMessageTemplateEditDialog,
    ScoutMessageTemplateDeleteDialog, ScoutMessageTemplateCreateDialog, Button, FlexRow, FlexColumn},
  mixins: [ApiMixin],
  data() {
    return {
      createTemplate: undefined,
      editTemplate: undefined,
      deleteTemplate: undefined
    }
  },
  beforeMount() {
    this.loadScoutMessageTemplates(this.companyId)
  },
  computed: {
    ...mapGetters("message", ["scoutTemplates"]),
    ...mapGetters("client", ["company"]),
    companyId() {
      return this.company.id
    }
  }
}
</script>

<style scoped>

</style>